import Layout from '@/layout/layout'

const intoManage = {
  path: '/intoManage',
  component: Layout,
  redirect: 'noRedirect',
  name: '旧机入库',
  children: [
    {
      path: 'createOutbound',
      component: () => import('@/views/intoManage/createOutbound/index'),
      name: '新增入库',
      meta: { title: '新增入库', noCache: true }
    },
    {
        path: 'receiptDoc',
        component: () => import('@/views/intoManage/receiptDoc/index'),
        name: '采购单据',
        meta: { title: '采购单据', noCache: true }
    },
  ]
}

export default intoManage